const SET_BASKET_DATA = 'app/SET_BASKET_DATA';

function setBasketData(data) {
    return {
        type: SET_BASKET_DATA,
        payload: {
            items: data
        }
    }
}

export {
    SET_BASKET_DATA,
    setBasketData
}